<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="inspectionReports"
        @select="selectTest"
        @select-all="selectAll">
      <div slot="toolbar">
        <el-button :loading="exportLoading" type="primary" @click="exportExcel()">
          导出检验记录
        </el-button>
        <el-button
            slot="toolbar"
            type="primary"
            size="mini"
            @click="$refs.editInspectionReport.open(0)">
          新建入库异常
        </el-button>
        <el-button :loading="exportLoading1" type="primary" @click="exportExcel1()">
          导出入库异常
        </el-button>
        <el-input
            ref="searchInput"
            v-model.trim="filter.filter"
            class="search-bar"
            clearable
            style="width: 260px;float: right;"
            placeholder="请输入"
            @keyup.enter.native="handleSearch">
          <el-button slot="append" icon="el-icon-search" @click="handleSearch">
            查询
          </el-button>
        </el-input>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="区域">
            <el-select v-model.trim="filter.storageInspectionType" clearable placeholder="请选择">
              <el-option
                  v-for="item in constant.toSelect(constant.storageInspectionType)"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </vm-search>
          <vm-search label="创建时间">
            <div class="block">
              <el-date-picker
                  v-model="filter.beginCreateTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  style="width: 165px"
                  placeholder="选择开始时间"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.endCreateTime"
                  value-format="yyyy-MM-dd 23:59:59"
                  type="date"
                  style="width: 165px"
                  placeholder="选择结束时间"/>
            </div>
          </vm-search>
          <vm-search label="客户合同号">
            <el-input v-model.trim="filter.clientContractNO" clearable/>
          </vm-search>
          <vm-search label="pc号">
            <el-input v-model.trim="filter.salesOrderNO" clearable/>
          </vm-search>
          <vm-search label="SAP销售单号">
            <el-input v-model.trim="filter.sapSalesOrderNO" clearable/>
          </vm-search>
          <vm-search label="报告编号">
            <el-input v-model.trim="filter.no" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="45"/>
      <el-table-column prop="productionOrderNO" width="110px" align="center" label="生产订单号">
        <template slot-scope="scope">
          <span
              style="color: #2d8cf0;cursor: pointer;"
              @click="$refs.preview.open(scope.row)">
            {{scope.row.productionOrderNO}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="clientContractNO" align="center" label="客户合同号"/>
      <el-table-column prop="sapSalesOrderNO" width="100px" align="center" label="SAP销售单号"/>
      <el-table-column prop="salesOrderNO" width="95" align="center" label="销售单号"/>
      <el-table-column prop="no" width="120" align="center" label="报告编号">
        <template slot-scope="scope">
          <span v-if="scope.row.no==='test'">***</span>
          <span v-else>{{scope.row.no}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdTime" align="center" width="180px" label="报告创建时间"/>
      <el-table-column prop="barcode" align="center" width="180px" label="条码"/>
      <el-table-column prop="flowStatus" align="center" label="流程状态">
        <template slot-scope="scope">
          {{constant.flowStatus[scope.row.flowStatus]}}
        </template>
      </el-table-column>
      <el-table-column prop="status" align="center" label="报告状态">
        <template slot-scope="scope">
          {{constant.reportStatus[scope.row.status]}}
        </template>
      </el-table-column>
      <el-table-column prop="problemDesc" align="center" label="问题描述"/>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate">
        <template slot-scope="scope">
          <el-button type="primary" @click="edit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <preview ref="preview" @save-success="getList(-1)"/>
    <inspection-report-edit ref="editInspectionReport" @save-success="getList(-1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "../../../util/constant";
  import constants from "@/util/constants";
  import Preview from "@/views/purchase/inspectionReport/Preview";
  import InspectionReportEdit from "@/views/purchase/inspectionReport/InspectionReportEdit";
  import auth from "@/util/loginUtil";

  export default {
    components: {InspectionReportEdit, Preview, VmTable, VmSearch},
    data() {
      return {
        constant,
        constants,
        currentUser: auth.getUserId(),
        reportStatus: constant.toSelect(constant.reportStatus, "addAll"),
        show: "",
        exportLoading: false,
        exportLoading1: false,
        submitLoading: false,
        filter: {
          filter: "",
          storageInspectionType: "",
          materialNo: "",
          salesOrderNO: "",
          no: "",
          problemClassification: "",
          qualitativeClassification: "",
        },
        details: [],
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      handleSearch() {
        this.getList(1);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
      },
      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic", "inspectionReports/exportReportList", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
      exportExcel1() {
        this.exportLoading1 = true;
        this.$http
          .exportFile("basic", "inspectionReports/exportInspection", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading1 = false;
          })
          .catch(() => {
            this.exportLoading1 = false;
          });
      },
      edit(row) {
        this.$refs.editInspectionReport.open(row);
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
